import Main from "./components/main"
import Title from "./components/title"

function App() {
  return (
    <div className="app-container">
      <Main />
    </div>
  )
}

export default App;
